import { clearStorage } from "../constant/helper";
import { ProfileReduxTypes } from "../constant/Types";

const profileModel = {
  mobileNumber: "",
  nationalCode: "",
  password: "",
  firstName: "",
  lastName: "",
  birthDate: "1360/06/06",
};
const data = sessionStorage.getItem("red-profile");
const initialize = data
  ? Object.assign(profileModel, JSON.parse(data))
  : profileModel;

export default function profile(state = initialize, action) {
  let res = {
    loading: false,
    hasError: false,
    data: {},
  };
  switch (action.type) {
    case ProfileReduxTypes.update:
      res = {
        loading: false,
        hasError: false,
        data: {},
      };
      res.data = Object.assign({}, state.data, action.data);
      sessionStorage.setItem("red-profile", JSON.stringify(res));
      return {
        loading: false,
        hasError: false,
        data: res,
      };
    case ProfileReduxTypes.update_failed:
      return {
        loading: false,
        hasError: true,
        data: {},
      };
    case ProfileReduxTypes.logout:
      res = {
        loading: false,
        hasError: false,
        data: {},
      };
      clearStorage();
      window.location.pathname = "";
      return res;
    case ProfileReduxTypes.FETCH_PROFILE:
      res = {
        loading: true,
        hasError: false,
        data: {},
      };
      sessionStorage.setItem("red-profile", JSON.stringify(res));
      return res;
    case ProfileReduxTypes.FETCH_PROFILE_SUCCESS:
      res = {
        loading: false,
        hasError: false,
        data: {},
      };
      res.data = Object.assign({}, state.data, action.data);
      sessionStorage.setItem("red-profile", JSON.stringify(res));
      return res;
    case ProfileReduxTypes.FETCH_PROFILE_FAILURE:
      res = {
        loading: false,
        hasError: true,
        data: {},
      };
      sessionStorage.setItem("red-profile", JSON.stringify(res));
      return res;
    default:
      return state;
  }
}
